import * as i0 from "@angular/core";
export class DropDownSearchStore {
}
DropDownSearchStore.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function DropDownSearchStore_Factory() { return new DropDownSearchStore(); }, token: DropDownSearchStore, providedIn: "root" });
export var DropDownSearchStoreKeys;
(function (DropDownSearchStoreKeys) {
})(DropDownSearchStoreKeys || (DropDownSearchStoreKeys = {}));
